import { BigInteger, MessageType } from 'app/modules/remote-control-ng/definitions';
import { MemoryBuffer } from '../../utils/memoryBuffer';
import { BaseMessage } from '../baseMessage';

export enum AdminCommandTypes {
    changeOrganizer = 0,            // change organizer
    changeController = 1,           // change controller
    addViewer = 2,                  // add viewer
    removeViewer = 3,               // remove viewer
    // changePresenter = 4,         // change presenter
    changeControllerRequest = 10,// change controller request
    // changePresenterRequest = 11, // change presenter request
    chat = 20,                   // chat
    joinSessionRequest = 30,        // join session request
    event = 31,                     // event
    multiviewInfo = 32,             // multiview information
    viewerList = 33,                // viewer list
    // startPresenter = 50,         // start presenter
    // stopPresenter = 51,          // stop presenter
    // pausePresenter = 52,         // pause presenter
    // resumePresenter = 53,        // resume presenter
    organizerChanged = 60,          // organizer changed
    controllerChanged = 61,         // controller changed
    // presenterChanged = 62,       // presenter changed
    // deviceDisconnected = 70,     // device disconnected
    // deviceReconnected = 71,      // device reconnected
    // organizerDisconnected = 72,  // organizer disconnected
    // organizerReconnected = 73,   // organizer reconnected
    helpDeskSetTicketId = 80     // help desk set ticket identifier
}

export interface IAdminMessageOptions {
    commandType: AdminCommandTypes,
    userId?: number,
    ticketId?: string;
    approved?: boolean,
    state: IAdminInfo // mcrc.com.Multiview based state
}

export interface IUserInfo {
    flags: number,
    userId: number,
    userName: string
}

export interface IAdminInfo {
    command: number,
    controller: number,
    organizer: number,
    myId: number,
    permissions: BigInteger,
    users: IUserInfo[]
}

/** PC_ADMIN MessageType */
export class AdminMessage extends BaseMessage implements IAdminMessageOptions {
    commandType: AdminCommandTypes;
    userId?: number;
    ticketId?: string;
    approved?: boolean;
    response?: IAdminInfo;

    public state: IAdminInfo;

    constructor(options?: Partial<AdminMessage>) {
        super();
        this.header.command = MessageType.PC_ADMIN;
        if (options) Object.assign(this, options);
    }

    public serializeBody(buffer: MemoryBuffer): void {
        buffer.writeUInt8(this.commandType);      // command
        if (this.commandType === AdminCommandTypes.helpDeskSetTicketId) {
            buffer.writeStringLE(this.ticketId);
        } else {
            buffer.writeInt32BE(this.userId); 
        }

        if (this.commandType === AdminCommandTypes.addViewer) {
            buffer.writeUInt8(!this.approved ? 0 : 1);
        }
    }

    public deserializeBody(buffer: MemoryBuffer): void {
        this.response = <IAdminInfo>{};
        // var err = header.errorCode;
        this.commandType = buffer.readUInt8();
        let name: string;
        let message: string;

        switch (this.commandType) {
            case AdminCommandTypes.changeControllerRequest:     // control request from other viewer
                this.userId = buffer.readUInt32BE();
                name = buffer.readString();
                console.log(`Admin: Control request from ${name}`);
                break;
            case AdminCommandTypes.chat:
                // chat message
                name = buffer.readString();
                const text = buffer.readString();
                console.log(`Admin: Chat message from ${name}: ${text}`);
                break;
            case AdminCommandTypes.joinSessionRequest:    // join session request
                this.userId = buffer.readInt32BE();
                name = buffer.readString();
                // TODO - Refresh session
                // const event = new CustomEvent('JoinSessionRequest', { user: userId, name: name });
                // document.dispatchEvent(event);
                break;

            case AdminCommandTypes.event:    // session event
                const evtType = buffer.readInt32BE();
                this.userId = buffer.readInt32BE();
                name = buffer.readString();
                message = buffer.readString();
                // TODO - refresh session
                // const event = new CustomEvent('SessionEvent', { type: evtType.toString(10), user: userId, name: name, message: message });
                // document.dispatchEvent(event);
                break;

            case AdminCommandTypes.multiviewInfo:    // session info
                this.response.myId = buffer.readInt32BE();
                this.response.permissions = buffer.readInt64BE();
                this.response.organizer = buffer.readInt32BE();
                this.response.controller = buffer.readInt32BE();

                // TODO - refresh permissions
                // if (response.permissions != 0) {
                //     RcContext.instance.securityContext.initialize(response.permissions);
                // }
                break;

            case AdminCommandTypes.viewerList:    // viewer list
                const fullList = buffer.readUInt8() != 0;
                let count = buffer.readUInt32BE();
                if (count > 0)
                    this.response.users = [];
                while (count-- > 0) {
                    const uid = buffer.readUInt32BE();
                    const uname = buffer.readString();
                    const flags = buffer.readUInt32BE();
                    const online = buffer.readUInt8();
                    this.response.users.push(<IUserInfo>{ flags: flags, userId: uid, userName: uname });
                    if ((flags & 0x0001) != 0)
                        this.response.organizer = uid;
                    if ((flags & 0x0002) != 0)
                        this.response.controller = uid;
                }
                // TODO - refresh UI
                break;

            case AdminCommandTypes.organizerChanged:
                this.response.organizer = buffer.readInt32BE();
                // TODO - refresh UI
                break;

            case AdminCommandTypes.controllerChanged:
                this.response.controller = buffer.readInt32BE();
                // TODO - refresh UI
                break;
        }
        this.state = this.response;
    }
}
